module.exports = __webpack_public_path__ + "img/dog-house.c8efbdd7.svg";